<div class="splash" #splash>
  <img src="./assets/img/logo/logo-endoso-powerpay-white.svg" alt="Logo de Powerpay" />
</div>
